import type { JSX } from 'react';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Alert } from '@feathr/components';

function ContactAccountingAlert(): JSX.Element {
  const { t } = useTranslation();
  return (
    <Alert title={t('Payment methods are managed by Feathr')} type={'info'}>
      <Trans t={t}>
        <p>
          Our accounting team handles payment methods and payment changes on your behalf. To set up
          or change how you pay, contact us at <strong>accounting@feathr.co</strong>.
        </p>
      </Trans>
    </Alert>
  );
}

export default ContactAccountingAlert;
